import { TAG_TYPES } from '../types/TagTypes';
export function convertDynamicPageModel(payload) {
    if (!payload || Object.keys(payload).length === 0) {
        return {
            tags: [],
        };
    }
    var tags = Object.assign({}, payload.description ? { description: payload.description } : {}, payload.keywords ? { keywords: payload.keywords } : {}, {
        robots: payload.noIndex === 'true' || payload.noIndex === true
            ? 'noindex'
            : 'index',
    }, (!Array.isArray(payload.metaTags) && payload.metaTags) || {});
    var parsedTags = Object.keys(tags).reduce(function (acc, curr) {
        var _a;
        var nameOrProperty = curr.indexOf('og:') === 0 ? 'property' : 'name';
        return acc.concat({
            type: TAG_TYPES.META,
            props: (_a = {},
                _a[nameOrProperty] = curr,
                _a.content = tags[curr],
                _a),
        });
    }, []);
    if (payload.title) {
        parsedTags.push({
            type: TAG_TYPES.TITLE,
            children: payload.title,
        });
    }
    return {
        tags: parsedTags,
    };
}
